import { render, staticRenderFns } from "./RequestAndResponse.vue?vue&type=template&id=2c42ae07&lang=pug&"
import script from "./RequestAndResponse.vue?vue&type=script&lang=ts&"
export * from "./RequestAndResponse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports